import {Injectable} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable()
export class WtfMatSidenavHelperService {
  sidenavInstances: MatSidenav[];

  constructor() {
    this.sidenavInstances = [];
  }

  setSidenav(id, instance): void {
    this.sidenavInstances[id] = instance;
  }

  getSidenav(id) {
    return this.sidenavInstances[id];
  }
}
